export const getAllModulesResourceTranslationIds = () => {
  const paths = import.meta.glob<true, any, any>(
    "../admin/modules/**/translations/*/de.json",
  );

  return Object.keys(paths).map((path) => {
    return path.split("/")[5];
  });
};
